module.exports = __webpack_public_path__ + "deb522fbe71864e8193383394183b55c.svg";